module.exports = __webpack_public_path__ + "static/media/waistFemale.5a2f1456.png";